import React from 'react';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import { t } from '../../../types/translation/Translator';
import { Icon } from '../../icons';
import { IconType } from '../../icons/Icon';
import { Card } from '../Card';
import { ObsoleteExportConfiguration } from '../../../types/export/exportConfiguration';

interface ExportConfigurationItemProps {
  item: ObsoleteExportConfiguration | null;
  onClick: () => void;
  selected?: boolean;
}

export default function ExportConfigurationItem({ item, onClick, selected = false }: ExportConfigurationItemProps) {
  return (
    <Card size={'md'} onClick={onClick} selected={selected}>
      <div className='flex flex-col place-items-center gap-2'>
        {item ? (
          <>
            <span className='fiv-viv fiv-icon-conf fiv-size-lg file_icon'></span>
            <p className='select-none text-sm font-semibold'>{item.name}</p>
          </>
        ) : (
          <>
            <Icon type={IconType.plus} size={'size-8'} stroke='stroke-body' />
            <p className='select-none text-sm font-semibold'>{t(TranslationKey.create).singular.upper}</p>
          </>
        )}
      </div>
    </Card>
  );
}
